import { render, staticRenderFns } from "./AddSale.vue?vue&type=template&id=1c49556d&"
import script from "./AddSale.vue?vue&type=script&lang=js&"
export * from "./AddSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\themes-coder\\rawal\\rawal-laravel11\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c49556d')) {
      api.createRecord('1c49556d', component.options)
    } else {
      api.reload('1c49556d', component.options)
    }
    module.hot.accept("./AddSale.vue?vue&type=template&id=1c49556d&", function () {
      api.rerender('1c49556d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/AddSale.vue"
export default component.exports